// @vendors
import React, { useMemo } from 'react'

// @components
import {
    Card,
    Grid,
    Typography,
  } from '../shared/MaterialUI';

// @assets
import { StatsStyles } from '../../assets/css/statsBoxes-style';
import AppButton from '../forms/AppButton';
import { theme } from '../../assets/theme';

const StatsBoxCard = ({
    title,
    iconStats,
    value,
    hasButton,
    handleClick,
    hasFooterText
}) => {
    const styles = useMemo(() => StatsStyles(), []);

  return (
    <Card elevation={0} sx={styles.box}>
        <Grid sx={styles.gridCard}>
            <Grid sx={styles.iconContainer}>
                {iconStats}
            </Grid>

            <Grid sx={styles.gridCardText}>    
                <Typography sx={styles.statsTitle}>{title}</Typography>
                <Typography sx={styles.statsData}>{value || '0'}</Typography>
                {hasFooterText && (
                    <Typography sx={styles.statsDataDescription}>
                        {hasFooterText}
                    </Typography>
                )}
            </Grid>
            
            {hasButton && (
                <AppButton
                    onPress={handleClick}
                    label="Search"
                    color="primary"
                    bgColor={theme.palette.primary.black}
                    sx={styles.buttonSearch}
                    size="medium"
                />
            )}
        </Grid>
    </Card>
  )
}

export default StatsBoxCard